export interface BrandInfo {
  title: string;
  subtitle: string;
  description: string;
  yearFounded: string;
  users: string;
  articles: string;
  dailyActive: string;
}

export const brandInfo: BrandInfo = {
  title: '真实 · 快速 · 全民爆料',
  subtitle: '51吃瓜App — 国内领先的娱乐资讯聚合平台',
  description: '51吃瓜App成立于2020年，致力于打造国内最大、最全的娱乐资讯聚合平台。我们汇聚全网最热门的明星爆料、网红吃瓜、社会热点等内容，通过智能算法精准推荐，让用户第一时间掌握最新最热的吃瓜资讯。平台日均活跃用户超百万，累计收录爆料文章超万篇，已成为国内吃瓜文化的标志性品牌。',
  yearFounded: '2020',
  users: '5,000,000+',
  articles: '15,000+',
  dailyActive: '1,200,000+',
};

export const advantages = [
  {
    title: '实时更新',
    description: '24小时不间断追踪全网热点，重大爆料5分钟内极速推送，绝不错过任何精彩瞬间。',
    icon: 'ri-timer-flash-line',
  },
  {
    title: '海量内容',
    description: '覆盖明星、网红、综艺、影视等多个领域，累计收录超过15000篇独家爆料与深度分析。',
    icon: 'ri-database-2-line',
  },
  {
    title: '用户共创',
    description: '开放用户投稿与爆料通道，每一位用户都可以成为吃瓜前线记者，共同丰富平台内容生态。',
    icon: 'ri-user-community-line',
  },
  {
    title: '智能推荐',
    description: '基于用户兴趣的AI算法精准推荐，越用越懂你，不错过任何你感兴趣的话题与人物。',
    icon: 'ri-brain-line',
  },
  {
    title: '多端同步',
    description: '支持iOS、Android、Web三端无缝切换，阅读进度与收藏内容实时同步，随时随地畅快吃瓜。',
    icon: 'ri-smartphone-line',
  },
  {
    title: '安全可靠',
    description: '严格的内容审核机制与隐私保护体系，保障用户信息安全的同时，确保内容真实可信赖。',
    icon: 'ri-shield-check-line',
  },
];

export const testimonials = [
  {
    name: '吃瓜群众小王',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20portrait%20silhouette%20with%20soft%20golden%20light%2C%20minimalist%20artistic%20style%2C%20clean%20simple%20composition%2C%20no%20facial%20details%2C%20ambient%20warm%20lighting%2C%20editorial%20photography%20aesthetic%2C%20no%20text&width=120&height=120&seq=avatar-001&orientation=squarish',
    role: '资深用户 · 使用2年',
    content: '自从用了51吃瓜，再也不用在微博、豆瓣到处找了。每天打开App就能看到最新最热的爆料，推送速度真的快，好几次我比朋友早知道热搜事件！',
  },
  {
    name: '娱乐圈观察员',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20portrait%20silhouette%20with%20amber%20lighting%2C%20minimalist%20artistic%20style%2C%20clean%20simple%20composition%2C%20no%20facial%20details%2C%20soft%20dramatic%20lighting%2C%20editorial%20photography%20aesthetic%2C%20no%20text&width=120&height=120&seq=avatar-002&orientation=squarish',
    role: '自媒体博主 · 使用1年',
    content: '作为自媒体人，51吃瓜是我每天必看的信息源。内容更新快、分类清晰，很多独家料都是从这里先爆出来的，帮我的账号涨了不少粉。',
  },
  {
    name: '八卦小能手',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20portrait%20silhouette%20with%20soft%20golden%20glow%2C%20minimalist%20artistic%20style%2C%20clean%20simple%20composition%2C%20no%20facial%20details%2C%20warm%20ambient%20lighting%2C%20editorial%20photography%20aesthetic%2C%20no%20text&width=120&height=120&seq=avatar-003&orientation=squarish',
    role: '吃瓜达人 · 使用3年',
    content: '每日大赛这个功能太有意思了！每天上班摸鱼的时候刷一刷，还能跟网友一起投票PK，评论区才是真正的快乐源泉。',
  },
];

export const contactInfo = {
  email: 'contact@51chigua.com',
  wechat: 'chigua51official',
  weibo: '@51吃瓜官方',
  address: '北京市朝阳区建国路88号SOHO现代城A座',
  phone: '400-888-5151',
  businessHours: '周一至周日 9:00 - 21:00',
};